(() => {
  const chartSelector = '.sd-z90-chart';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getCharts(root) {
    if (!(root instanceof Element || root instanceof Document)) return [];
    const charts = Array.from(root.querySelectorAll(chartSelector));
    if (root instanceof Element && root.matches(chartSelector)) charts.unshift(root);
    return charts;
  }

  function initChart(chart) {
    if (chart.dataset.respectoStorageChartReady === 'true') return;

    const rows = Array.from(chart.querySelectorAll('.sd-z90-row'));
    if (!rows.length) return;

    const capacities = rows.map((row) => {
      const label = row.querySelector('.sd-z90-label')?.textContent || '';
      const match = label.match(/[\d.]+/);
      return match ? Number(match[0]) : NaN;
    });
    const validCapacities = capacities.filter(Number.isFinite);
    const maximumCapacity = validCapacities.length ? Math.max(...validCapacities) : 0;

    const fills = rows.map((row, index) => {
      const fill = row.querySelector('.sd-z90-fill');
      if (!fill) return null;

      const providedWidth = Number(fill.dataset.width);
      const calculatedWidth = maximumCapacity > 0 && Number.isFinite(capacities[index])
        ? (capacities[index] / maximumCapacity) * 100
        : NaN;
      const targetWidth = Number.isFinite(providedWidth) && providedWidth > 0
        ? providedWidth
        : calculatedWidth;

      if (!Number.isFinite(targetWidth)) return null;

      fill.style.width = '0%';
      fill.dataset.respectoTargetWidth = String(Math.min(100, Math.max(0, targetWidth)));
      return fill;
    }).filter(Boolean);

    if (!fills.length) return;
    chart.dataset.respectoStorageChartReady = 'true';

    const reveal = () => {
      chart.classList.add('is-visible');

      if (reducedMotion.matches) {
        fills.forEach((fill) => {
          fill.style.transition = 'none';
          fill.style.width = `${fill.dataset.respectoTargetWidth}%`;
        });
        return;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          fills.forEach((fill) => {
            fill.style.width = `${fill.dataset.respectoTargetWidth}%`;
          });
        });
      });
    };

    if (!('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      reveal();
    }, {
      threshold: 0.22,
      rootMargin: '0px 0px -8% 0px'
    });

    observer.observe(chart);
  }

  function init(root = document) {
    getCharts(root).forEach(initChart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();